"use client";

import {
  DraggableBlock,
  EditorProvider,
  NoContentFound,
  SiteProvider,
  useSite,
} from "@wazoe/elements";
import { useEffect, useLayoutEffect, useMemo } from "react";
import AOS from "aos";

const Content = ({ header, content, footer, locale, site }) => {
  const { setLocale } = useSite();

  useEffect(() => {
    setLocale(locale);
  }, [locale, setLocale]);

  return (
    <>
      {[...header, ...content, ...footer].map((block) => {
        return (
          <DraggableBlock
            elementId={block.id}
            key={block.id}
            {...{
              elementProps: block.props,
              ...{ forms: site.forms },
            }}
          />
        );
      })}
    </>
  );
};

const ContentBlock = ({ page, header, footer, site, locale, slug }) => {
  const activePage =
    page?.data?.[0].path === "/"
      ? `/${locale}`
      : `/${locale}${page.data?.[0]?.path}`;

  const repeatable = useMemo(() => {
    return site?.repeatables.find((r) => r.plural === page?.repeatable?.plural);
  }, [site, page?.repeatable?.plural]);

  const repeatableItem = useMemo(() => {
    return repeatable?.items.find((i) => i.slug === slug[2]);
  }, [repeatable, slug]);

  const activeProduct = useMemo(() => {
    if (slug?.[1] !== "product") return null;

    return site?.products?.find((product) => product.slug === slug?.[2]) || null;
  }, [site?.products, slug]);

  useLayoutEffect(() => {
    AOS.init({ easing: "ease-out-cubic", once: true, offset: 50 });

    setTimeout(() => {
      AOS.refresh();
    }, 500);
  }, []);

  return (
    <>
      <EditorProvider initMode="production" backendApi={site.backendApi}>
        <SiteProvider
          initLocale={site.defaultLanguage.code.toLowerCase()}
          defaultLocale={site?.defaultLanguage?.code}
          pages={site?.pages}
          forms={site?.forms}
          menus={site?.menus}
          languages={site?.languages}
          activePage={activePage}
          textPlaceholders={repeatableItem?.placeholders}
          repeatableItem={repeatableItem}
          repeatables={site?.repeatables}
          products={site?.products}
          activeProduct={activeProduct}
        >
          {page.data?.[0]?.content?.length === 0 && <NoContentFound />}
          <Content
            header={header}
            content={page.data?.[0]?.content}
            footer={footer}
            locale={locale}
            site={site}
          />
        </SiteProvider>
      </EditorProvider>
    </>
  );
};

export default ContentBlock;
